<template>
    <div>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <h1 class="page-title">{{ $t('Dashboard') }}</h1>
      </div>

      <div class="row">

        <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
          <card-component
            :value="card1Value"
            background-color="main-color"
            title="estates.agents"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
          <card-component
            :value="card2Value"
            background-color="main-color"
            title="user.Payment.AXONAUT"/>
        </div>

      </div>

      <template>
        <div>
          <div class="mt-4 mb-3 d-flex align-items-center justify-content-between">
            <div>
              <h1 class="page-title">{{
                  $t('estates.agents')
                }}</h1>
            </div>
            <b-button variant="primary" v-on:click="clickOnCreateBtn()">
              {{ $t('Add') }}
            </b-button>
          </div>

          <b-card class="mt-2 mb-4 shadow-sm">
            <div class="mb-2">
              <div class="text-right mb-2 mb-lg-0">
                <b-link class="reset-link" @click="resetTable">
                  {{ $t('ResetDisplay') }}
                </b-link>
              </div>
            </div>
            <div class="d-flex flex-column flex-md-row justify-content-md-between mb-4">

              <b-input-group
                class="mr-md-4" size="sm"
                style="width: 33%">
                <b-input-group-prepend>
                  <b-input-group-text class="search-input-prepend">
                    <search-icon size="18"/>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchQuery"
                  :class="{'active': searchQuery}"
                  :placeholder="$t('Research')"
                  class="search-input"
                  type="search">
                </b-form-input>
              </b-input-group>

              <b122-table-pagination
                :currentPage="currentPage"
                :perPage="perPage"
                :perPageOptions="perPageOptions"
                :totalRows="totalRows"
                class="mt-2 mt-lg-0"
                @changeCurrentPage="changeCurrentPage"
                @changePerPage="changePerPage"/>
            </div>
            <b-table id="table-clients-mdb" ref="table"
                     :fields="tableFields"
                     :key="tableDataKey"
                     :items="paginatedItems"
                     :thead-class="'row-header'"
                     borderless
                     show-empty
                     responsive
                     sort-icon-left
                     stacked="lg"
                     @head-clicked="sortBy"
                     @reset="resetTable"
                     striped>


              <template #cell(show)="row">
                <div class="actions-container">
                  <button class="show-action-btn" @click="clickOnShowBtn(row)">
                    <eye-icon size="18"/>
                  </button>
                </div>
              </template>

              <template #cell(username)="row">
                <div>
                  <div>{{ splitEmail(row.item.username).username }}</div>
                  <div>@{{ splitEmail(row.item.username).domain }}</div>
                </div>
              </template>


              <template #cell(subscriptionType)="row">
                <div v-if="row.item.subscriptionType == 'COLLABORATOR'">
                  {{ $t(row.item.role) }}
                </div>
                <div v-else>
                  {{ $t('user.Payment.' + row.item.subscriptionType) }}
                </div>
              </template>


              <template #cell(subscriptionStatus)="row">
                {{ $t('subscription.status.' + row.item.subscriptionStatus) }}
              </template>

              <template #cell(actions)="row">
                <div class="actions-container text-right">
                  <button v-if="$store.getters.username==('maintenance-aprilyos@bleu122.com')&&$store.getters.isAdmin"
                          class="impersonate-btn mr-1"
                          @click="impersonate(row)">
                    <user-icon size="18"/>
                  </button>
                  <button v-if="$store.getters.isAdmin" class="show-action-btn edit mr-1" @click="clickOnEditBtn(row)">
                    <pencil-icon size="18"/>
                  </button>
                  <button v-if="$store.getters.isAdmin" class="show-action-btn delete" @click="clickOnDeleteBtn(row)">
                    <trash-icon size="18"/>
                  </button>
                </div>
              </template>
              <template #cell(subscriptionDateNoFormat)="row">
                    <span v-if="row.item.subscriptionDateNoFormat">
                      {{ formatDate(row.item.subscriptionDateNoFormat) }}
                    </span>
                <span v-else>
                      -
                    </span>
              </template>
              <template #cell(isLNIGroup)="row">
                    <span v-if="row.item.isLNIGroup === true">
                      Oui
                    </span>
                <span v-else-if="row.item.isLNIGroup === false">
                      Non
                    </span>
                <span v-else>
                      -
                    </span>
              </template>


            </b-table>
          </b-card>

          <Item-delete-modal
            id="user-delete-modal"
            :beginsWithVoyel="false"
            :isFeminine="false"
            :selectedItem="selectedUser"
            controllerName="user"
            itemSingularName="client"
            itemSingularNameUpp="Client"
            @didDeleteItem="didDeleteUser()">
          </Item-delete-modal>
        </div>
      </template>

    </div>
</template>

<script>

import CardComponent from "../../components/b122/CardComponent";
import DashboardUsersComponent from "../dashboard/components/DashboardUsersComponent";
import {mapActions} from "vuex";
import {bus} from "../../main";
import B122Table from "../../components/b122/B122Table";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import api from "../../services/api";
import TokenService from "../../services/tokenService";
import B122TablePagination from "../../components/b122/B122TablePagination";

export default {
  name: "DashboardClient",

  components: {
    CardComponent,
    DashboardUsersComponent,
    ItemDeleteModal,
    B122Table,
    B122TablePagination
  },

  data() {
    return {
      card1Value: null,
      card2Value: null,
      card3Value: null,
      card4Value: null,
      totalCount: 0,
      tableDataKey: 0,
      allowCreate: this.$store.getters.isAdmin,
      allowEdit: this.$store.getters.isAdmin,
      allowDelete: this.$store.getters.isAdmin,
      itemsCharges: [],
      selectedUser: null,
      searchQuery: '',
      currentSortKey: '', // clé du champ de tri
      currentSortOrder: 'asc', // ordre de tri: 'asc' ou 'desc'
      currentPage: 1, // keep
      perPage: 50, // keep
      perPageOptions: [
        {
          value: 10,
          text: '10 ' + this.$i18n.t('perPage')
        },
        {
          value: 50,
          text: '50 ' + this.$i18n.t('perPage')
        },
        {
          value: 100,
          text: '100 ' + this.$i18n.t('perPage')
        },
        {
          value: 2147483647, // Max integer value
          text: this.$i18n.t('seeEverything')
        }
      ],
      totalRows: 0,
    }
  },

  watch: {
    filteredItems(newFilteredItems) {
      this.totalRows = newFilteredItems.length;
    },
  },

  mounted() {
    this.fetchData()
  },

  computed:{
    filteredItems() {
      const searchLower = this.searchQuery.trim().toLowerCase();
      let filteredData = this.itemsCharges;

      // Filtrer les éléments par la recherche
      if (searchLower) {
        filteredData = filteredData.filter(item => this.matchesSearch(item, searchLower));
      }

      // Trier les éléments globalement par `currentSortKey` et `currentSortOrder`
      if (this.currentSortKey) {
        filteredData.sort((a, b) => {
          const aValue = this.getValueByKey(a, this.currentSortKey);
          const bValue = this.getValueByKey(b, this.currentSortKey);

          if (aValue < bValue) return this.currentSortOrder === 'asc' ? -1 : 1;
          if (aValue > bValue) return this.currentSortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return filteredData;
    },

    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },

    tableFields() {
      return [
        {
          label: this.$i18n.t('Show'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('user.Lastname'),
          key: 'tostring',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Username'),
          key: 'username',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Entreprise'),
          key: 'entreprise',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Operations'),
          key: 'nbOperations',
          sortable: true
        },
        {
          label: this.$i18n.t('user.nbLots'),
          key: 'nbLots',
          sortable: true
        },
        {
          label: this.$i18n.t('user.nbCollaborators'),
          key: 'nbCollaborators',
          sortable: true
        },
        {
          label: this.$i18n.t('user.LNIGroup'),
          key: 'isLNIGroup',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Payment'),
          key: 'subscriptionType',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Subscription'),
          key: 'subscriptionStatus',
          sortable: false
        },
        {
          label: this.$i18n.t('user.endAbonnement'),
          key: 'subscriptionDateNoFormat',
          sortable: true
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }
  },

  methods: {

    ...mapActions(["setImpersonateMode"]),

    resetTable() {
      this.currentPage = 1;
      this.searchQuery = "";
      this.currentSortKey = "id";
      this.currentSortOrder = 'asc';
      this.perPage = 50;
      this.tableDataKey ++;

      this.sortBy(this.currentSortKey);
    },




    setTotalCount(totalCount) {
      this.totalCount = totalCount;
    },

    matchesSearch(item, searchLower) {
      if (item === null || item === undefined) {
        return false;
      }
      if (typeof item === 'object') {
        return Object.values(item).some(val => this.matchesSearch(val, searchLower));
      }
      return String(item).toLowerCase().includes(searchLower);
    },

    getValueByKey(item, key) {
      const value = key.split('.').reduce(
        (obj, keyPart) => (obj && obj[keyPart] !== undefined) ? obj[keyPart] : null,
        item
      );

      if (key === 'isLNIGroup') {
        if (value === true) return 1;
        if (value === false) return 0;
        return -1;
      }

      return value;
    },

    splitEmail(email) {
      if (email) {
        const parts = email.split('@');
        return {username: parts[0], domain: parts[1]};
      }
      return {username: '', domain: ''};
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'UserCreate'
      });
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'UserShow',
        params: {
          userId: row.item.id
        }
      });
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: row.item.id
        }
      });
    },

    clickOnDeleteBtn(row) {
      this.selectedUser = row.item;
      this.$bvModal.show('user-delete-modal');
    },

    didDeleteUser() {
      this.selectedUser = null;
      this.fetchData();
    },

    impersonate(row) {
      bus.$emit("changingImpersonate");

      let data = new FormData();
      data.append('username', row.item.username);
      api({
        method: 'POST',
        url: `user/impersonate`,
        data: data
      })
        .then((response) => {
          TokenService.addImpersonate(response.data.impersonateToken);
          this.setImpersonateMode(response.data);
          if(response.data.roles && response.data.roles.includes("ROLE_AGENT_IMMO")) {
            this.$router.push({
              name: 'DashboardAgentImmo'
            });
          } else {
            this.$router.push({
              name: 'Dashboard',
            });
          }
        });
    },


    async fetchData() {
      await this.fetchDashboardData()
      await this.fetchUsers()
    },

    fetchDashboardData() {
      api
        .get(`/user/getUsersClientsDashboardClientAdminCards`)
        .then(response => {
          this.card1Value = response.data.totalClients
          this.card2Value = response.data.totalAxonaut
        })
    },

    fetchUsers(){
      api
        .get(`/user/getUsersClientsDashboardClientAdmin`)
        .then(response => {
         this.itemsCharges = response.data
        })
    },

    sortBy(key) {
      if (this.currentSortKey === key) {
        this.currentSortOrder = this.currentSortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSortKey = key;
        this.currentSortOrder = 'asc';
      }
    },

    changeCurrentPage(newCurrentPage) {
      this.currentPage = newCurrentPage
    },

    changePerPage(newPerPage) {
      this.perPage = newPerPage
      this.currentPage = 1
    },
    formatDate(timestamp) {
      if (!timestamp) return ''
      const d = new Date(timestamp)
      // Exemple simple : dd/mm/yyyy
      const day   = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year  = d.getFullYear()
      return `${day}/${month}/${year}`
    },

  }

}
</script>

<style scoped>
.actions-container{
  display: flex;
  flex-wrap: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/client/DashboardClient.vue